// Wzory dokumentów do druku — jedno źródło dla podglądu, pomiaru i wydruku (HTML jako tekst, wartości escapowane).
// Treść: wzory z serwisu z przyjętymi korektami K i propozycjami P (docs/redesign/dokumenty/changelog-dokumenty-v01.md);
// zgłoszenie zbycia/nabycia — wzór 1:1 z korektami językowymi (raport wdrożenia).
import { esc, fmtDate, odm, parsePrice, todayIso, trim } from './text'

// pola: n — nazwa, l — etykieta, t — typ (text, date, time, tel, area, words, check, radio), v — walidator (text.js),
// w — szerokość w siatce (s, m, half; domyślnie cała), opt — opcjonalne, h — podpowiedź, up — wielkie litery,
// im — inputmode, ml — maxlength, suffix — jednostka, own — ukryte przy „Jestem właścicielem”, sub — śródtytuł
function party (p) {
    return [
        { n: `${p}_fullname`, l: 'Imię i nazwisko albo nazwa firmy' },
        { n: `${p}_street`, l: 'Ulica, numer domu i lokalu', h: 'Adres zamieszkania albo siedziby' },
        { n: `${p}_zip`, l: 'Kod pocztowy', v: 'zip', im: 'numeric', w: 's', ml: 6 },
        { n: `${p}_town`, l: 'Miejscowość', w: 'm' },
        { n: `${p}_id`, l: 'Seria i numer dokumentu tożsamości', up: true, w: 'half', h: 'Dowód osobisty albo paszport' },
        { n: `${p}_id_issuer`, l: 'Dokument wydany przez', w: 'half', opt: true, h: 'np. Prezydent Miasta Poznania' },
        { n: `${p}_pesel_nip`, l: 'PESEL albo NIP', v: 'peselnip', im: 'numeric', w: 'half', h: 'NIP — gdy stroną jest firma' },
    ]
}

function vehicle (p, own) {
    const f = [
        { n: `${p}_make`, l: 'Marka i model', w: 'half', h: 'np. Skoda Octavia' },
        { n: `${p}_number`, l: 'Numer rejestracyjny', v: 'reg', up: true, w: 'half' },
    ]
    if (own) f.push({ n: 'car_owner_me', l: 'Jestem właścicielem tego pojazdu', t: 'check' })
    else f.push({ n: 'hitcar_driver', l: 'Kierujący pojazdem poszkodowanego', opt: true, h: 'Jeśli inny niż właściciel' })
    f.push(
        { n: `${p}_owner_fullname`, l: 'Właściciel — imię i nazwisko albo nazwa', own },
        { n: `${p}_owner_address`, l: 'Adres właściciela', v: 'addr', own },
        { n: `${p}_oc_firm`, l: 'Ubezpieczyciel OC', w: 'half' },
        { n: `${p}_oc_number`, l: 'Numer polisy OC', up: true, w: 'half' },
        { n: `${p}_oc_valid`, l: 'Polisa ważna do', t: 'date', w: 'half', opt: true },
        { n: own ? 'damage' : 'hitcar_damage', l: 'Zakres uszkodzeń', t: 'area' },
    )
    return f
}

function owner (p) {
    const opt = p === 'coowner'
    return [
        { n: `${p}_name_firm`, l: 'Imię i nazwisko albo nazwa firmy', opt },
        { n: `${p}_street`, l: 'Ulica, numer domu i lokalu', h: 'Adres zamieszkania albo siedziby', opt },
        { n: `${p}_zip`, l: 'Kod pocztowy', v: 'zip', im: 'numeric', w: 's', ml: 6, opt },
        { n: `${p}_town`, l: 'Miejscowość', w: 'm', opt },
        { n: `${p}_pesel`, l: 'PESEL albo REGON', v: 'peselregon', im: 'numeric', w: 'half', h: 'REGON — gdy właścicielem jest firma', opt },
    ]
}

export const FORMS = {
    umowa: [
        { s: 'Data i miejsce zawarcia', f: [
            { n: 'date', l: 'Data zawarcia umowy', t: 'date', w: 'half', today: true },
            { n: 'hour', l: 'Godzina', t: 'time', w: 'half', opt: true },
            { n: 'city', l: 'Miejscowość' },
        ] },
        { s: 'Sprzedający', f: party('seller') },
        { s: 'Kupujący', f: party('buyer') },
        { s: 'Pojazd', f: [
            { n: 'car_make', l: 'Marka i model', h: 'np. Toyota Corolla', w: 'm' },
            { n: 'car_production_year', l: 'Rok produkcji', v: 'year', im: 'numeric', w: 's', ml: 4 },
            { n: 'car_vin', l: 'Numer nadwozia (VIN)', v: 'vin', up: true, h: '17 znaków, w dowodzie rejestracyjnym pole E', ml: 20 },
            { n: 'car_registration', l: 'Numer rejestracyjny', v: 'reg', up: true, w: 'half' },
            { n: 'car_engine_number', l: 'Numer silnika', up: true, w: 'half', opt: true },
            { n: 'car_card_number', l: 'Numer karty pojazdu', up: true, w: 'half', opt: true, h: 'Jeśli karta została wydana', hideIf: 'car_card_none' },
            { n: 'car_card_none', l: 'Karty pojazdu nie wydano', t: 'check', w: 'half' },
            { n: 'car_mileage', l: 'Przebieg', v: 'num', im: 'numeric', suffix: 'km', w: 'half' },
            { n: 'car_color', l: 'Kolor', w: 'half', opt: true },
        ] },
        { s: 'Cena i płatność', f: [
            { n: 'price', l: 'Cena', v: 'price', im: 'decimal', suffix: 'zł', w: 'half' },
            { n: 'price_word', l: 'Cena słownie', t: 'words' },
            { n: 'payment', l: 'Sposób zapłaty', t: 'radio', o: [['', 'nie wpisuj'], ['gotówką', 'gotówka'], ['przelewem na rachunek bankowy Sprzedającego', 'przelew']] },
        ] },
        { s: 'Przekazane z pojazdem i dodatkowe ustalenia', f: [
            { n: 'car_extras', l: 'Co Kupujący otrzymuje razem z samochodem', t: 'area', h: 'np. 2 kluczyki, dowód rejestracyjny, karta pojazdu, książka serwisowa' },
            { n: 'terms', l: 'Dodatkowe ustalenia stron', t: 'area', opt: true, h: 'Drukowane tylko, gdy wpiszesz treść.' },
        ] },
    ],
    oswiadczenie: [
        { s: 'Zdarzenie', f: [
            { n: 'date', l: 'Data', t: 'date', w: 'half', today: true },
            { n: 'hour', l: 'Godzina (około)', t: 'time', w: 'half' },
            { n: 'city', l: 'Miejscowość' },
            { n: 'street', l: 'Ulica albo skrzyżowanie' },
        ] },
        { s: 'Sprawca (kierujący)', f: [
            { n: 'fullname', l: 'Imię i nazwisko' },
            { n: 'address', l: 'Adres zamieszkania', v: 'addr', h: 'Ulica i numer, kod pocztowy, miejscowość' },
            { n: 'phone', l: 'Telefon', t: 'tel', v: 'phone', w: 'half' },
            { n: 'license_category', l: 'Kategoria prawa jazdy', up: true, w: 'half', h: 'np. B' },
            { n: 'license_number', l: 'Numer prawa jazdy', up: true, w: 'half' },
            { n: 'license_date', l: 'Data wydania prawa jazdy', t: 'date', w: 'half' },
            { n: 'license_issuer', l: 'Organ wydający prawo jazdy', opt: true, h: 'np. Prezydent Miasta Poznania' },
        ] },
        { s: 'Pojazd sprawcy', f: vehicle('car', true) },
        { s: 'Pojazd poszkodowanego', f: vehicle('hitcar', false) },
        { s: 'Okoliczności i uszkodzenia', f: [
            { n: 'circumstances', l: 'Okoliczności zdarzenia', t: 'area', h: 'Krótko i konkretnie: kto jechał skąd i dokąd, co się stało.' },
            { n: 'other_damage', l: 'Inne szkody', t: 'area', opt: true, h: 'np. uszkodzone ogrodzenie, znak drogowy; jeśli brak — zostaw puste albo wpisz „brak”.' },
        ] },
        { s: 'Świadkowie', note: 'Opcjonalnie. Świadek podpisuje się na wydruku.', f: [
            { sub: 'Świadek 1' },
            { n: 'witness_1_fullname', l: 'Imię i nazwisko', opt: true },
            { n: 'witness_1_address', l: 'Adres', v: 'addr', opt: true, w: 'half' },
            { n: 'witness_1_phone', l: 'Telefon', t: 'tel', v: 'phone', opt: true, w: 'half' },
            { sub: 'Świadek 2' },
            { n: 'witness_2_fullname', l: 'Imię i nazwisko', opt: true },
            { n: 'witness_2_address', l: 'Adres', v: 'addr', opt: true, w: 'half' },
            { n: 'witness_2_phone', l: 'Telefon', t: 'tel', v: 'phone', opt: true, w: 'half' },
        ] },
    ],
    zgloszenie: [
        { s: 'Miejsce i data', f: [
            { n: 'city', l: 'Miejscowość', w: 'half' },
            { n: 'date', l: 'Data zgłoszenia', t: 'date', w: 'half', today: true },
        ] },
        { s: 'Właściciel', f: owner('owner') },
        { s: 'Współwłaściciel', note: 'Opcjonalnie — gdy pojazd ma współwłaściciela.', f: owner('coowner') },
        { s: 'Urząd', f: [
            { n: 'city_office_in', l: 'Miejscowość, w której urząd ma siedzibę', h: 'Wydział komunikacji starostwa powiatowego albo urzędu miasta' },
        ] },
        { s: 'Pojazd i transakcja', f: [
            { n: 'action', l: 'Zgłaszam', t: 'radio', o: [['', 'skreślę na wydruku'], ['nabycie', 'nabycie'], ['zbycie', 'zbycie']] },
            { n: 'make', l: 'Marka pojazdu', w: 'half' },
            { n: 'registration_number', l: 'Numer rejestracyjny', v: 'reg', up: true, w: 'half' },
            { n: 'vin', l: 'Numer identyfikacyjny VIN', v: 'vin', up: true, h: 'Nadwozia, podwozia lub ramy — 17 znaków, w dowodzie rejestracyjnym pole E', ml: 20 },
            { n: 'date_of_transaction', l: 'Data nabycia lub zbycia', t: 'date', w: 'half' },
        ] },
        { s: 'Załączniki', f: [
            { n: 'bool_document', l: 'Dokument własności (np. umowa, faktura, postanowienie sądu)', t: 'check' },
            { n: 'bool_payment', l: 'Opłata skarbowa', t: 'check' },
            { n: 'bool_authorization', l: 'Pełnomocnictwo/upoważnienie', t: 'check' },
            { n: 'bool_other_attachment', l: 'Inne', t: 'check' },
            { n: 'other_attachment', l: 'Inne załączniki', opt: true, showIf: 'bool_other_attachment' },
        ] },
    ],
}

// etykiety egzemplarzy (PU7); zgłoszenie drukuje się w jednym egzemplarzu
export const COPIES = {
    umowa: { labels: ['Egzemplarz Sprzedającego', 'Egzemplarz Kupującego'], text: 'Drukuj 2 egzemplarze — po jednym dla Sprzedającego i Kupującego', on: true },
    oswiadczenie: { labels: ['Egzemplarz poszkodowanego', 'Egzemplarz sprawcy'], text: 'Drukuj 2 egzemplarze — dla poszkodowanego i dla sprawcy', on: false },
    zgloszenie: null,
}

export function eachField (kind, cb) {
    FORMS[kind].forEach((s) => s.f.forEach((f) => f.n && cb(f)))
}

export function fieldDef (kind, n) {
    let r = null
    eachField(kind, (f) => { if (f.n === n) r = f })
    return r
}

export function defaults (kind, today = todayIso()) {
    const d = {}
    eachField(kind, (f) => {
        if (f.today) d[f.n] = today
        if (f.t === 'radio') d[f.n] = ''
    })
    return d
}

// pole w podglądzie, które podświetlić dla pola formularza (ulica, kod i miejscowość składają się w adres)
export function previewKey (n) {
    const m = /^(seller|buyer|owner|coowner)_(street|zip|town)$/.exec(n || '')
    return m ? `${m[1]}_address` : n
}

// b(): wartość albo pusta linia do wpisania (podpowiedź pod linią tylko, gdy pole puste)
function b (d, n, w, hint) {
    const v = trim(d[n])
    return v
        ? `<span class="v" data-f="${n}">${esc(v)}</span>`
        : `<span class="b" data-f="${n}" style="--w:${w || 32}mm"${hint ? ` data-h="${hint}"` : ''}></span>`
}

function lines (d, n, k) {
    const v = trim(d[n])
    if (v) return `<span class="v" data-f="${n}">${esc(v).replace(/\n/g, '<br>')}</span>`
    return `<span class="lines" data-f="${n}">${'<span></span>'.repeat(k)}</span>`
}

// wartość albo linia, pod spodem zawsze podpis pola (kolumny właściciela w zgłoszeniu)
function captioned (d, n, caption) {
    const v = trim(d[n])
    return `<p class="d-capt">${v ? `<span class="v" data-f="${n}">${esc(v)}</span>` : `<span class="b d-full" data-f="${n}"></span>`}<span class="d-hint">${caption}</span></p>`
}

function box (on) {
    return `<span class="d-box">${on ? '×' : ''}</span>`
}

function address (d, p) {
    return [trim(d[`${p}_street`]), [trim(d[`${p}_zip`]), trim(d[`${p}_town`])].filter(Boolean).join(' ')].filter(Boolean).join(', ')
}

function prep (raw, kind) {
    const d = { ...raw }
    eachField(kind, (f) => { if (f.up && d[f.n]) d[f.n] = String(d[f.n]).toUpperCase() })
    ;['date', 'license_date', 'car_oc_valid', 'hitcar_oc_valid', 'date_of_transaction'].forEach((k) => { if (d[k]) d[k] = fmtDate(d[k]) })
    if (kind === 'umowa') {
        d.seller_address = address(d, 'seller')
        d.buyer_address = address(d, 'buyer')
        if (trim(d.car_mileage)) d.car_mileage = `${trim(d.car_mileage)} km`
    } else if (kind === 'zgloszenie') {
        d.owner_address = address(d, 'owner')
        d.coowner_address = address(d, 'coowner')
    } else if (d.car_owner_me) {
        d.car_owner_fullname = d.fullname
        d.car_owner_address = d.address
    }
    return d
}

function umowa (d, raw, o) {
    const who = (p, label, pre) => `<div class="d-who"><p>${pre}<b>${label}</b></p><p>${b(d, `${p}_fullname`, 80)}</p><p>Adres ${b(d, `${p}_address`, 72)}</p>` +
        `<p>Dokument tożsamości nr ${b(d, `${p}_id`, 38)} wydany przez ${b(d, `${p}_id_issuer`, 50)}</p><p>PESEL/NIP ${b(d, `${p}_pesel_nip`, 45)}</p></div>`
    const pr = parsePrice(raw.price || '')
    const zl = pr ? odm(pr.zl, ['złoty', 'złote', 'złotych']) : 'złotych'
    const pay = trim(d.payment) ? ` ${esc(d.payment)}` : o.blank ? ` w formie ${b({}, 'payment', 40)}` : ''
    const card = d.car_card_none ? 'karta pojazdu: nie wydano' : `nr karty pojazdu: ${b(d, 'car_card_number', 30)}`
    const extra = trim(d.terms) || o.blank
    return '<h2 class="d-title">Umowa sprzedaży samochodu</h2>' +
        `<p class="has-h">Umowa zawarta w dniu ${b(d, 'date', 32, '(dzień, miesiąc, rok)')} r.${trim(d.hour) || o.blank ? ` o godz. ${b(d, 'hour', 14)}` : ''} w ${b(d, 'city', 45, '(miejscowość)')} pomiędzy:</p>` +
        `<div class="d-cols d-parties">${who('seller', 'Sprzedającym:', '')}${who('buyer', 'Kupującym:', 'a ')}</div>` +
        `<p class="d-par">§ 1</p><p>Przedmiotem umowy jest sprzedaż samochodu:<br>Marka i model: ${b(d, 'car_make', 45)}, rok produkcji: ${b(d, 'car_production_year', 16)}, nr nadwozia: ${b(d, 'car_vin', 50)}` +
        `, nr silnika: ${b(d, 'car_engine_number', 35)}, nr rejestracyjny: ${b(d, 'car_registration', 25)}, ${card}, przebieg: ${b(d, 'car_mileage', 25)}, kolor: ${b(d, 'car_color', 25)}</p>` +
        '<p class="d-par">§ 2</p><p>Sprzedający oświadcza, że samochód będący przedmiotem niniejszej umowy stanowi jego własność, nie toczy się wobec niego żadne postępowanie w związku z ww. samochodem, samochód jest wolny od wad prawnych i praw osób trzecich oraz nie stanowi przedmiotu zabezpieczenia.</p>' +
        `<p class="d-par">§ 3</p><p>Strony ustaliły wartość przedmiotu niniejszej umowy na kwotę: ${b(d, 'price', 30)} zł (słownie: ${b(d, 'price_word', 90)} ${zl}${pr && pr.gr ? ` ${pr.gr}/100` : ''}).</p>` +
        '<p class="d-par">§ 4</p><p>1. Sprzedający przenosi na Kupującego własność samochodu określonego w § 1, zaś Kupujący tytułem ceny zobowiązuje się zapłacić na rzecz Sprzedającego kwotę ustaloną w § 3 niniejszej umowy.<br>' +
        `2. Strony stwierdzają, że samochód określony w § 1 został Kupującemu wydany, a cena uiszczona w wysokości ${b(d, 'price', 30)} zł na rzecz Sprzedającego${pay}.</p>` +
        `<p class="d-par">§ 5</p><p>Kupujący oświadcza, że w dniu podpisania umowy wraz z samochodem określonym w § 1 zostały przekazane mu: ${trim(d.car_extras) ? `${b(d, 'car_extras')}.` : lines(d, 'car_extras', 2)}</p>` +
        '<p class="d-par">§ 6</p><p>Kupujący oświadcza, że dokładnie zapoznał się ze stanem technicznym nabywanego samochodu i nie ma do niego żadnych zastrzeżeń.</p>' +
        '<p class="d-par">§ 7</p><p>Strony ustaliły, że wszystkie koszty wynikające z zawarcia niniejszej umowy ponosi Kupujący.</p>' +
        (extra ? `<p class="d-par">§ 8</p><p>Dodatkowe ustalenia stron: ${lines(d, 'terms', 3)}</p>` : '') +
        `<p class="d-par">§ ${extra ? 9 : 8}</p><ol class="d-ol"><li>Wszelkie zmiany i uzupełnienia niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li><li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają odpowiednie przepisy Kodeksu cywilnego.</li><li>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</li></ol>` +
        '<div class="d-sign"><div><span class="line"></span>(sprzedający)</div><div><span class="line"></span>(kupujący)</div></div>'
}

function oswiadczenie (d) {
    const car = (p, dmg, title) => `<h3>${title}</h3><p>Marka i model: ${b(d, `${p}_make`, 40)}, nr rej. ${b(d, `${p}_number`, 25)}` +
        (p === 'hitcar' ? `, kierujący: ${b(d, 'hitcar_driver', 50)}` : '') +
        `, właściciel: ${b(d, `${p}_owner_fullname`, 55)}, zam. ${b(d, `${p}_owner_address`, 70)}, pojazd posiada ważne ubezpieczenie OC w ${b(d, `${p}_oc_firm`, 40)}` +
        `, nr polisy: ${b(d, `${p}_oc_number`, 35)}, ważne do: ${b(d, `${p}_oc_valid`, 25)}. Zakres uszkodzeń w pojeździe: ${trim(d[dmg]) ? b(d, dmg) : lines(d, dmg, 2)}</p>`
    const wit = (i) => {
        const p = `witness_${i}_`
        return `<p>${i}. ${b(d, `${p}fullname`, 42)}, zam. ${b(d, `${p}address`, 46)}, tel. ${b(d, `${p}phone`, 24)}, podpis: ${b({}, '', 24)}</p>`
    }
    return '<h2 class="d-title">Oświadczenie sprawcy kolizji drogowej</h2>' +
        `<p>Ja, niżej podpisany/a: ${b(d, 'fullname', 55)}, zamieszkały/a: ${b(d, 'address', 75)}, tel. ${b(d, 'phone', 30)}, posiadający/a prawo jazdy kategorii: ${b(d, 'license_category', 15)}, numer: ${b(d, 'license_number', 35)}` +
        `, wydane dnia ${b(d, 'license_date', 25)} przez ${b(d, 'license_issuer', 50)}, oświadczam, że w dniu: ${b(d, 'date', 25)}, około godziny: ${b(d, 'hour', 15)}, w miejscowości: ${b(d, 'city', 40)}` +
        `, na ulicy (skrzyżowaniu): ${b(d, 'street', 60)}, kierując pojazdem:</p>` +
        `<div class="d-cols"><div>${car('car', 'damage', 'POJAZD SPRAWCY')}</div><div><p>Spowodowałem/am kolizję drogową, w wyniku której uszkodzeniu uległ:</p>${car('hitcar', 'hitcar_damage', 'POJAZD POSZKODOWANEGO')}</div></div>` +
        '<div class="d-sketch"><div class="d-sketch-box"><span>Szkic sytuacji</span></div><p class="d-cap">Na szkicu strzałką zaznaczyć kierunek uderzenia.</p></div>' +
        `<h3>Okoliczności i inne skutki zdarzenia</h3><p>Okoliczności: ${trim(d.circumstances) ? b(d, 'circumstances') : lines(d, 'circumstances', 3)}</p>` +
        `<p>Inne szkody: ${b(d, 'other_damage', 140)}</p>` +
        `<p>Świadkowie zdarzenia</p>${wit(1)}${wit(2)}` +
        '<div class="d-sign"><div><span class="line"></span>(data i czytelny podpis poszkodowanego)</div><div><span class="line"></span>(data i czytelny podpis sprawcy)</div></div>'
}

function zgloszenie (d) {
    const col = (p, title) => `<div><h3 class="d-c">${title}</h3>${captioned(d, `${p}_name_firm`, '(imię i nazwisko lub nazwa firmy)')}` +
        `${captioned(d, `${p}_address`, '(adres zamieszkania lub siedziby)')}${captioned(d, `${p}_pesel`, '(PESEL lub REGON)')}</div>`
    // wybór w formularzu skreśla drugą możliwość; bez wyboru — „(niepotrzebne skreślić)” jak we wzorze
    const act = d.action === 'nabycie' ? '<b data-f="action">nabyciu</b>, <s>zbyciu</s>'
        : d.action === 'zbycie' ? '<s>nabyciu</s>, <b data-f="action">zbyciu</b>'
            : '<b data-f="action">nabyciu, zbyciu</b> (niepotrzebne skreślić)'
    return '<h2 class="d-title">Zgłoszenie sprzedaży/kupna samochodu</h2>' +
        `<p class="d-right has-h">${b(d, 'city', 45, '(miejscowość)')}, dnia ${b(d, 'date', 32, '(dzień, miesiąc, rok)')}</p>` +
        `<div class="d-cols d-owners">${col('owner', 'WŁAŚCICIEL')}${col('coowner', 'WSPÓŁWŁAŚCICIEL')}</div>` +
        `<div class="d-office"><p><b>Do Wydziału Komunikacji Starostwa Powiatowego / Urzędu Miasta</b></p><p>z siedzibą w mieście ${b(d, 'city_office_in', 60)}.</p></div>` +
        '<h3>Zawiadamiam o nabyciu lub zbyciu pojazdu</h3>' +
        `<p>Działając na podstawie art. 78 ust. 2 pkt 1 ustawy – Prawo o ruchu drogowym zawiadamiam(y) o ${act} pojazdu marki ${b(d, 'make', 45)} zarejestrowanego pod numerem rejestracyjnym ${b(d, 'registration_number', 30)}` +
        ` z numerem identyfikacyjnym VIN (nadwozia, podwozia lub ramy) ${b(d, 'vin', 55)}.</p>` +
        `<p>Data nabycia lub zbycia dotychczas zarejestrowanego pojazdu: ${b(d, 'date_of_transaction', 32)}</p>` +
        '<h3>Załączniki</h3>' +
        `<p class="d-att" data-f="bool_document">${box(d.bool_document)} Dokument własności (np. umowa, faktura, postanowienie sądu)</p>` +
        `<p class="d-att" data-f="bool_payment">${box(d.bool_payment)} Opłata skarbowa</p>` +
        `<p class="d-att" data-f="bool_authorization">${box(d.bool_authorization)} Pełnomocnictwo/upoważnienie</p>` +
        `<p class="d-att" data-f="bool_other_attachment">${box(d.bool_other_attachment)} Inne ${b(d, 'other_attachment', 90)}</p>` +
        '<p class="d-decl"><b>Oświadczam, że podane w zawiadomieniu dane i informacje są aktualne i zgodne ze stanem faktycznym.</b></p>' +
        '<div class="d-sign d-sign-one"><div><span class="line"></span>(data i czytelny podpis)</div></div>'
}

// o.blank — pusty wzór do wypełnienia ręcznie (dodatkowe miejsca: godzina, sposób zapłaty, § 8 umowy)
export function docHtml (kind, raw, o = {}) {
    const src = o.blank ? {} : raw || {}
    const d = prep(src, kind)
    if (kind === 'umowa') return umowa(d, src, o)
    if (kind === 'zgloszenie') return zgloszenie(d)
    return oswiadczenie(d)
}

export function docFoot (label, page) {
    return `<div class="d-foot"><span>Dokument przygotowany w serwisie samochody.pl</span><span>${[label, page].filter(Boolean).join(' · ')}</span></div>`
}
